/**
 * Claves de caché de TanStack Query del panel de retenciones (FEAT-105-11).
 *
 * `document-withholdings`: lista TF3 del documento que la grilla renderiza. Se
 * invalida tras agregar/modificar/eliminar/recalcular (los totales T1/TF4b cambian).
 * `withholding-classes` / `withholding-keys`: catálogos del modal Agregar.
 */
export const withholdingsQueryKey = (documentId: string) =>
  ['document-withholdings', documentId] as const;

export const withholdingClassesQueryKey = () => ['withholding-classes'] as const;

export const withholdingKeysQueryKey = (classId: string) =>
  ['withholding-keys', classId] as const;

export const withholdingOperationCentersQueryKey = () =>
  ['withholding-operation-centers'] as const;
